import React, { useEffect } from "react";
import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { Button } from "./ui/button";

export default function ThemeToggle({ className = "" }) {
  const { resolvedTheme, setTheme } = useTheme();
  const light = resolvedTheme === "light";
  const label = light ? "Passa al tema scuro" : "Passa al tema chiaro";
  // The phone browser bar follows the chosen theme, not only the device setting.
  useEffect(() => {
    if (!resolvedTheme) return;
    document.querySelectorAll('meta[name="theme-color"]').forEach((meta) => {
      meta.setAttribute("content", resolvedTheme === "light" ? "#f4f7fa" : "#050815");
    });
  }, [resolvedTheme]);
  return (
    <Button type="button" variant="ghost" size="icon" className={className} aria-label={label} title={label}
      onClick={() => setTheme(light ? "dark" : "light")} data-testid="theme-toggle">
      {light ? <Moon className="h-5 w-5" aria-hidden="true" /> : <Sun className="h-5 w-5" aria-hidden="true" />}
    </Button>
  );
}
